/**
 * Format a row × column image size for display.
 *
 * E.g:
 *  formatImageSize(512, 512) => '512 × 512'
 *  formatImageSize(undefined, 512) => '--'
 */
export function formatImageSize(
    rows: number | undefined | null,
    columns: number | undefined | null,
): string {
    if (rows && columns) return `${rows} × ${columns}`;
    return '--';
}